import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { EASE } from "@/components/Reveal";
import { SMS_DONE_KEY, SmsSignup } from "@/components/SmsSignup";
import { setScrollLock } from "@/lib/lenis";

const DISMISS_KEY = "sviin_sms_popup_dismissed";

export const SmsPopup = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(SMS_DONE_KEY) || sessionStorage.getItem(DISMISS_KEY)) return undefined;
    const t = setTimeout(() => setOpen(true), 4000);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    setScrollLock(open);
    const onKey = (e) => { if (e.key === "Escape") close(); };
    if (open) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  const close = () => {
    sessionStorage.setItem(DISMISS_KEY, "1");
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-[65] grid place-items-center p-4">
          <motion.div data-testid="sms-popup-overlay" className="absolute inset-0 bg-[#111111]/45 backdrop-blur-[3px]" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} onClick={close} />
          <motion.div
            data-testid="sms-popup"
            role="dialog"
            aria-modal="true"
            aria-label="Get 10% off by text"
            data-lenis-prevent
            initial={{ opacity: 0, y: 24, scale: 0.98 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 24, scale: 0.98 }}
            transition={{ duration: 0.6, ease: EASE }}
            className="relative max-h-[90svh] w-full max-w-[460px] overflow-y-auto border border-[#111111]/15 bg-[#F4F2EE] p-7 shadow-[0_40px_80px_-30px_rgba(17,17,17,0.5)] md:p-10"
          >
            <button data-testid="sms-popup-close-button" aria-label="Close" onClick={close} className="absolute right-2 top-2 grid h-11 w-11 place-items-center hover:text-[#E2541B]">
              <X size={18} strokeWidth={1.5} />
            </button>
            <p className="label text-[#111111]/60">Text club</p>
            <p data-testid="sms-popup-offer" className="mt-5 font-['Geist',sans-serif] text-7xl font-light leading-none tracking-[-0.06em] md:text-8xl">
              10% <span className="text-3xl tracking-[-0.03em] md:text-4xl">off</span>
            </p>
            <h2 className="mt-4 font-['Geist',sans-serif] text-xl font-light leading-snug tracking-[-0.02em] md:text-2xl">
              your first order when you sign up for texts — plus first word on every drop.
            </h2>
            <div className="mt-7">
              <SmsSignup source="popup" onDone={() => setTimeout(() => setOpen(false), 3500)} />
            </div>
            <button data-testid="sms-popup-no-thanks" onClick={close} className="label draw-link mt-6 text-[10px] text-[#111111]/60">
              No thanks
            </button>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};
